<template>
  <div :class="['app-container', $style.wrap]">
    <global-header mode="dark" showBack background="rgba(255, 255, 255, 0.8)">
      <template v-slot:left>
        <img v-if="logo" :src="logo" :class="$style.logo" />
      </template>
    </global-header>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalHeader from "@/components/GlobalHeader";

export default {
  name: "BlankLayout",
  data() {
    return {};
  },
  components: { GlobalHeader },
  computed: {
    ...mapGetters(["logo"])
  }
};
</script>

<style module lang="less">
.wrap {
  background-color: @white;
}

.logo {
  .size(0.75rem, 0.6rem);
  margin-left: @global-header-padding;
}
</style>
